// Create Pop Up Cart
let pop_up_cart = `
    <div id="box-pop-up-cart" class="box-pop-up-cart">
        <div class="title">CART</div>
        <div class="list-item">
        </div>
        <div class="footer">
            <div class="total-price"></div>
            <a href="/checkout">Checkout</a>
        </div>
    </div>

`;

jQuery("body").append(pop_up_cart);

// Get Cart
function getCart() {
    jQuery.getJSON("/cart.js", function (cart) {
        document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: cart,
            })
        );
        jQuery(".box-pop-up-cart .list-item .box-items").remove();
        jQuery(".data-cart-count").text(cart.item_count);
        let cartData = cart.items;
        if (cart.item_count > 0) {
            refreshCart(cart, cartData);
        }
    });
}

jQuery(".change-item").click(function () {
    alert("click add or min");
});

// Refresh Cart
function refreshCart(cart, cartData) {
    console.log("masuk refresh cart", cartData);
    let data_list_item = "";
    let final_line_price = 0;
    const formatRupiah = (money) => {
        return new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: 0,
        }).format(money);
    };
    $.each(cartData, function (index, value) {
        var pricena = "" + value.final_line_price + "";
        var pricenaFormat = pricena.substring(0, pricena.length - 2);
        let variant = value.variant_options.toString();
        variant = variant.replace(",", " / ");
        final_line_price = final_line_price + value.final_line_price;
        data_list_item += `
        <div class="box-items"">
            <div class="box-image">
                <img src="${value.image}" alt="${value.title}"/>
                <div class="variant">${variant}</div>
            </div>
            <div class="box-description">
                <div class="title">${value.title}</div>
                <div class="price">${formatRupiah(pricenaFormat)}</div>
                <div class="line-item-operations">
                    <button type="button" data-variant-id="${
                        value.variant_id
                    }" data-quantity="${
            value.quantity
        }" class="button change-item">+</button>
                    <input type="number" class="input-value" value="${
                        value.quantity
                    }" />
                    <button type="button" data-variant-id="${
                        value.variant_id
                    }" data-quantity="${
            value.quantity
        }" class="button change-item">-</button>
                </div>
            </div>
        </div>
    `;
    });

  console.log(formatRupiah(final_line_price))

    jQuery(".total-price").text(formatRupiah(final_line_price/100));
    jQuery(".box-pop-up-cart .list-item").append(data_list_item);

    jQuery(".change-item").click(function () {
        var idnaItem = jQuery(this).attr("data-variant-id");
        var qty = parseInt(jQuery(this).attr("data-quantity"));
        console.log("idnaItem", idnaItem);
        var url = "/cart/change.js";
        if (jQuery(this).text() == "+") {
            qty = 1;
            url = "/cart/add.js";
            console.log(qty);
        } else if (jQuery(this).text() == "-") {
            qty = qty - 1;
        }

        $.ajax({
            type: "POST",
            url: url,
            dataType: "json",
            data: {
                id: parseFloat(idnaItem),
                quantity: qty,
            },
        })
            .then((data) => {
                getCart();
            })
            .catch((error) => {
                console.error(
                    "Error add to cart",
                    error.responseJSON.description
                );
                alert(error.responseJSON.description);
            });
    });
}

$(".form-add-to-cart").submit(function (event) {
    event.preventDefault();
    let data = jQuery(this).attr("data-variant-id");
    let items = [{ id: data, quantity: 1 }];

    //Add to cart

    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: { items },
    })
        .then((data) => {
            console.log("Success:", data);
            setTimeout(function () {
                getCart();
                jQuery(".box-pop-up-cart").toggle();
            }, 400);
            setTimeout(function () {
                jQuery(".box-pop-up-cart").toggle();
            }, 4000);
        })
        .catch((error) => {
            console.log("error", error);
            alert(error.responseJSON.description);
        });
});

// Product Template
jQuery(".form-add-to-cart-product-template").click(function () {
    let id_from_param = jQuery(
        ".form-add-to-cart-product-template input"
    ).val();
    let searchParams = new URLSearchParams(window.location.search);
    let id_from_url = searchParams.get("variant"); // true

    let id_variant = null;
    if (id_from_url == null) {
        id_variant = id_from_param;
        console.log("dari param");
    } else {
        id_variant = id_from_url;
        console.log("dari url");
    }

    let items = [{ id: id_variant, quantity: 1 }];

    //Add to cart

    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: { items },
    })
        .then((data) => {
            console.log("Success:", data);
            setTimeout(function () {
                getCart();
                jQuery(".box-pop-up-cart").toggle();
            }, 400);
            setTimeout(function () {
                jQuery(".box-pop-up-cart").toggle();
            }, 4000);
        })
        .catch((error) => {
            console.log("error", error);
            alert(error.responseJSON.description);
        });
});

$('.quick-add .btn-add-cart-end-year').click(function(event) {
    event.preventDefault();

    const html = $(this).prev('.form-size-variant-wrapper').html();
    $.fancybox.open(html);
});

$(document).on('click', 'form.form-size-variant label.SizeSwatch', function (event) {
    var disableSwatch = $(this).attr('disabled');
    if(disableSwatch){
        return false;
    }
    $(this).prev('input').prop('checked', true);
});

$(document).on('submit', 'form.form-size-variant', function (event) {
    event.preventDefault();

    let varId = $(this).find('input:checked').val();
    // addItemToCartEndYear(varId, 1);
    let items = [{ id: varId, quantity: 1 }];
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: { items },
    })
    .then((data) => {
        console.log("Success:", data);
        setTimeout(function () {
            getCart();
            $("[data-fancybox-close]").trigger("click");
            jQuery(".box-pop-up-cart").toggle();
        }, 400);
        setTimeout(function () {
            jQuery(".box-pop-up-cart").toggle();
        }, 4000);
    })
    .catch((error) => {
        console.log("error", error);
        alert(error.responseJSON.description);
    });
});
console.log("staging")